import { SmoothSampling } from '@shm-open/utilities';
import { constants } from './utils';
const maxSamples = 8;
const latencySampling = new SmoothSampling(maxSamples);
const serverTimeDiffSampling = new SmoothSampling(maxSamples);
let lastPingPongReceived = 0;
export const onPingPongMessageReceived = (msg) => {
    const now = Date.now();
    const { clientTimeMS, serverTimeMS } = msg;
    const clientTime = Number(clientTimeMS);
    const latency = (now - clientTime) * 0.5;
    latencySampling.append(latency);
    const serverTime = Number(serverTimeMS);
    const serverTimeDiff = serverTime + latency - now;
    serverTimeDiffSampling.append(serverTimeDiff);
    lastPingPongReceived = now;
};
/**
 * get current server time accroding to time diff calculated in socket ping-pong message,
 * it fallbacks to the getServerTime from @shm/interface if socket is not connected.
 */
export const getServerTimeBySocket = () => {
    if (Date.now() - lastPingPongReceived > constants.pingPongTimeout) {
        // socket already timeout, return
        return undefined;
    }
    return Math.round(Date.now() + serverTimeDiffSampling.get());
};
/**
 * get connection latency (ping)
 */
export const getConnectionLatency = () => {
    return latencySampling.get();
};
